import { getShopConfig, isShopId, SHOP_OPTION_LIST } from 'constant/shop';

/**
 * 根据店铺 ID 获取对应的库存地
 */
export const getStockPlaceByStoreId = (storeId?: number) => {
  if (!storeId || !isShopId(storeId)) return undefined;
  return getShopConfig(storeId).stockPlace;
};

/**
 * 根据库存地获取对应的店铺 ID
 */
export const getStoreIdsByStockPlace = (stockPlace?: string) => {
  if (!stockPlace) return undefined;

  return SHOP_OPTION_LIST.find(
    (option) => getShopConfig(option.value).stockPlace === stockPlace,
  )?.value;
};
